import React from 'react';

import { IconBasePropsWithColor } from './IconBase';

import { colors } from 'styles/cp';

const Mobile: React.FC<IconBasePropsWithColor> = ({
  width = 14,
  height = 20,
  color = colors.gray,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H11C12.6569 20 14 18.6569 14 17V3C14 1.34315 12.6569 0 11 0ZM12 17C12 17.5523 11.5523 18 11 18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2H4V3C4 3.55228 4.44772 4 5 4H9C9.55228 4 10 3.55228 10 3V2H11C11.5523 2 12 2.44772 12 3V17Z"
        fill={color}
      />
    </svg>
  );
};

export default Mobile;
